import React, { ReactNode } from 'react';

import classNames from 'classnames';

import LabelValueItem from '../../label-value-item/label-value-item';

import './ui-list.scss';

interface UiListProps {
  sm?: boolean;
  list: { value: string | ReactNode; label: string }[];
  className?: string;
}

const UiList: React.FC<UiListProps> = ({ sm, list, className = '' }) => {
  const renderList = () =>
    list.map((item, index) => (
      <li key={`list-item-${index}`} className="list__item">
        <LabelValueItem title={item.label} text={item.value} sm={sm} />
      </li>
    ));

  return (
    <ul
      className={classNames('list', {
        'list--sm': sm,
        [className]: !!className,
      })}
    >
      {renderList()}
    </ul>
  );
};

export default UiList;
